'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _App = require('./App.css');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return _promise2.default.resolve();
  }
}]), _dec2 = (0, _reactCssModules2.default)(_App2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).call(this, props));
  }
  //


  (0, _createClass3.default)(App, [{
    key: 'render',
    value: function render() {
      _config2.default.app.head.meta = _config2.default.app.head.meta.map(function (meta) {
        // since config.js doesnt have access to import, we will inject the image path here
        // after a replacement of the absolute url with
        if (meta.property === 'og:image' || meta.property === 'twitter:image') {
          meta.content = _config2.default.domain + '../../../static/images/' + _config2.default.imageSocialShare.replace(/.*dist/, '/dist');
        }
        return meta;
      });
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement('div', { id: 'anchor-top' }),
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_components.HeaderMenu, null),
        _react2.default.createElement(
          'div',
          { styleName: 'content' },
          this.props.children
        ),
        _react2.default.createElement(_components.Footer, null),
        _react2.default.createElement(_components.AppDisclaimer, null)
      );
    }
  }]);
  return App;
}(_react.Component)) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1328
// module chunks = 0